<template>
  <div class="box" :class="margin_top">
    <div class="text">{{ text ? text + '：' : '' }}</div>
    <select class="select" v-model="value" @change="getValue">
      <option v-for="item in options" v-bind:key="item.id" :value="item.id">{{ item.text ? item.text : item.name +
        (item.remark ? `(${item.remark})` : '') }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "SelectBox",
  props: {
    text: { type: String },
    name: { type: String },
    options: { type: Array },
    margin_top: { type: String, default: 'high' },
    defaultValue: { type: Number, default: 0 }
  },
  data() {
    return {
      value: this.defaultValue,
    }
  },
  watch: {
    // 每当 defaultValue 改变时，这个函数就会执行
    defaultValue(newValue) {
      this.value = newValue;
    }
  },
  methods: {
    getValue: function () {
      this.$emit('getValue', this.value);
    }
  }
}
</script>

<style scoped>
.box {
  text-align: center;
  font-size: var(--ecs-font-md);
}

.text {
  display: inline-block;
  width: var(--ecs-label-width);
  text-align: right;
  margin: auto clamp(0.75rem, 2vw, 1.5rem);
}

.select {
  width: var(--ecs-control-width-sm);
  max-width: 90vw;
  box-sizing: border-box;
  min-height: var(--ecs-form-control-min-height);
  padding: var(--ecs-form-control-padding-y) var(--ecs-form-control-padding-x);
  line-height: 1.2;
}

.high {
  margin-top: clamp(1rem, 3vw, 2rem);
}

.short {
  /*margin-top: 1vh;*/
}

@media (max-width: 640px) {
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .text {
    box-sizing: border-box;
    width: var(--ecs-control-width-sm);
    max-width: 90vw;
    margin: 0 0 0.25rem;
    text-align: left;
  }

  .text:empty {
    display: none;
  }
}
</style>
